// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"373e6b42","384":"b7b567b4","511":"03bcbd88","776":"dd32517a","787":"ec704a7a"}[chunkId] + ".chunk.js";
};